<template>
  <div>
    <div class="head__wrapper">
      <span class="title-text">{{
        $l('form_label_sample_details') || '样品明细'
      }}</span>
      <el-button
        type="primary"
        plain
        size="mini"
        class="ml-3"
        @click="onOpenChooseSample"
        v-if="!disabled"
        >{{ $l('btn_select_sample') || '选择样品' }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onOpenChooseSample() {
      this.$emit('openChooseSample')
    },
  },
}
</script>
<style lang="scss" scoped>
.head__wrapper {
  display: flex;
  align-items: center;
  .title-text {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
  }
}
</style>
